module.exports = __webpack_public_path__ + "static/media/poster.7c44b1ee.png";